import { useController, useWatch } from "react-hook-form";
import type { Lens } from "@hookform/lenses";
import type { PlacementFormPosition } from "@design-lab/shared/types";

export function usePlacementPosition(lens: Lens<PlacementFormPosition>) {
  const { control, name } = lens.interop();
  const { field } = useController({ control, name });
  const placement = useWatch({ control, name });

  const setPlacement = (newPlacement: PlacementFormPosition) => {
    field.onChange(newPlacement, {
      shouldDirty: true,
      shouldTouch: true
    });
  };

  return {
    placement,
    setPlacement
  };
}
